import { PayrollPage } from '@repo/ccc-main-app-lib/src/pages/PayrollPage.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/user/$userId/payroll')({
  component: UserPayrollPage,
})

function UserPayrollPage() {
  const { userId } = Route.useParams()

  return <PayrollPage userId={userId} />
}
